import { Controller } from 'stimulus';

// A same-page link into a collapsible section: opens the <details> that
// holds the target, then scrolls to it (a link to a hidden row would not).
// <div data-controller="open-target"><a href="#row_1" data-action="click->open-target#go">
export default class extends Controller {
  go(event) {
    const hash = event.currentTarget.getAttribute('href');
    const target = hash && hash.startsWith('#') && document.querySelector(hash);
    if (!target) return;

    event.preventDefault();
    const details = target.closest('details');
    if (details) details.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
